export const globalApi = {
	// 绑定微信
	wxBind:{
		url:'/wrzs/social/bind',
		method:"POST"
	},
	
	//	提煤单
	//	获取发运计划列表
	GetOrderPlan: {
		url: '/wrzs/wx/getOrderPlan',
		method: 'GET'
	},
	//获取发运计划详情
	// GetOrderPlanDetail: {
	// 	url: '/wrzs/wx/GetOrderPlanDetail',
	// 	method: 'GET'
	// },
	/**
	 * @修改后的获取发运计划详情
	 */
	xiangqingList: {
		url: '/wrzs/userOperation/xiangqingList',
		method: 'GET'
	},


	// 客户领取
	customerGet: {
		url: "/wrzs/wx/customerGet",
		method: "POST"
	},
	//	转发
	// forward: {
	// 	url: "/wrzs/wx/forward",
	// 	method: "POST"
	// },
	/**
	 * @转发修改
	 */
	forward: {
		url: "/wrzs/userOperation/forward",
		method: "POST"
	},

	// 货代首页列表
	// huoDaiList: {
	// 	url: "/wrzs/wx/huoDaiList",
	// 	method: "GET"
	// },
	/**
	 * @货代首页列表修改
	 */
	huoDaiList: {
		url: "/wrzs/userOperation/huoDaiList",
		method: "GET"
	},

	//司机首页列表
	// qiangDanList: {
	// 	url: "/wrzs/wx/qiangDanList",
	// 	method: "GET"
	// },
	/**
	 * @司机首页列表修改
	 */
	qiangDanList: {
		url: "/wrzs/userOperation/qiangDanList",
		method: "GET"
	},

	//抢单
	// qiangDan: {
	// 	url: "/wrzs/wx/qiangDan",
	// 	method: "POST"
	// },
	/**
	 * @抢单修改
	 */
	qiangDan: {
		url: "/wrzs/userOperation/qiangDan",
		method: "POST"
	},

	//取消抢单
	quXiaoQiangDan: {
		url: "/wrzs/wx/quXiaoQiangDan",
		method: "POST"
	},
	//预约列表
	// yuYueList: {
	// 	url: "/wrzs/wx/yuYueList",
	// 	method: "GET"
	// },
	/**
	 * @预约列表修改
	 */
	yuYueList: {
		url: "/wrzs/userOperation/yuYueList",
		method: "GET"
	},

	//预约
	// yuYue: {
	// 	url: "/wrzs/wx/yuYue",
	// 	method: "POST"
	// },
	/**
	 * @预约修改
	 */
	yuYue: {
		url: "/wrzs/userOperation/yuYue",
		method: "POST"
	},

	//获取提煤单详情
	// getTakeCoal: {
	// 	url: "/wrzs/wx/getTakeCoal",
	// 	method: "GET"
	// },
	/**
	 * @获取提煤单详情修改后
	 */
	getTakeCoal: {
		url: "/wrzs/userOperation/getTakeCoal",
		method: "GET"
	},


	//	用户
	// 获取用户信息
	getUserEntity: {
		url: '/wrzs/userentity/getUserEntity',
		method: 'GET'
	},
	// 修改用户信息
	updateUser: {
		url: "/wrzs/wx/updateUser",
		method: "POST"
	},
	// 获取用户信息
	getUserById: {
		url: '/wrzs/wx/getUserById',
		method: 'POST'
	},
	//获取货代列表
	getAllHuoDaiByCustomerId: {
		url: "/wrzs/wx/getAllHuoDaiByCustomerId",
		method: "GET"
	},
	//邀请货代
	bindHuoDai: {
		url: "/wrzs/wx/bindHuoDai",
		method: "POST"
	},
	//删除货代
	deleteHuoDai: {
		url: "/wrzs/wx/deleteHuoDai",
		method: "POST"
	},
	//获取货代详情
	getHuoDaiDetail: {
		url: "/wrzs/wx/getHuoDaiDetail",
		method: "GET"
	},
	//获取司机列表
	GetUserFleet: {
		url: "/wrzs/wx/getUserFleet",
		method: "GET"
	},
	//邀请司机
	bindUserFleet: {
		url: "/wrzs/wx/bindUserFleet",
		method: "POST"
	},
	//删除司机
	deleteSiJi: {
		url: "/wrzs/wx/deleteSiJi",
		method: "POST",
	},


	//	车辆
	// 获取车队列表
	getFleet: {
		url: "/wrzs/wx/getFleet",
		method: "GET"
	},
	//新增车队
	saveFleet: {
		url: "/wrzs/wx/saveFleet",
		method: "POST"
	},
	// 删除车队
	deleteFleet: {
		url: "/wrzs/wx/deleteFleet",
		method: "POST"
	},

	/**
	 * @签到
	 */
	arrive: {
		url: '/wrzs/userOperation/arrive',
		method: 'POST'
	},
	/**
	 * @入场申请
	 */
	// 新增
	saveRCSQ: {
		url: "/wrzs/tminapply/save",
		method: 'POST'
	},
	// 修改
	updateByIdRCSQ: {
		url: "/wrzs/tminapply/updateById",
		method: 'PUT'
	},
	// 查询
	pageRCSQ: {
		url: "/wrzs/tminapply/page",
		method: 'GET'
	},

	/**
	 * @称重
	 */
	saveWeigh: {
		url: '/wrzs/userOperation/saveWeigh',
		method: 'POST'
	},
	// 获取称重信息
	weighList: {
		url: "/wrzs/userOperation/weighList",
		method: 'GET'
	},

	// 提煤单日志查询
	coalDayPage: {
		url: "/wrzs/tmtaskcoallog/page",
		method: 'GET'
	}
}
